import { render, staticRenderFns } from "./HrSalaryInsBatchDetail.vue?vue&type=template&id=40639214&scoped=true&"
import script from "./HrSalaryInsBatchDetail.vue?vue&type=script&lang=js&"
export * from "./HrSalaryInsBatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./HrSalaryInsBatchDetail.vue?vue&type=style&index=0&id=40639214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40639214",
  null
  
)

export default component.exports